import React from "react";
import Table from "../../../../../../../app/components/Table";
import { FiEdit } from "react-icons/fi";

const TemplateEmail = ({ dataTemplates, setSelectedTemplate, setIsTemplateModalOpen }) => {
  const columnsTemplates = [
    { titulo: "Nome", campo: "nome" },
    { titulo: "Assunto", campo: "assunto" },
    { titulo: "Sequência", campo: "sequencia", apenasDesktop: true },
    { titulo: "Criado em", campo: "criadoEm" },
    { titulo: "Status", campo: "status", tipo: "status", centralizado: true },
    { titulo: "Ações", campo: "acoes", tipo: "acoes", centralizado: true },
  ];

  const renderizarStatus = (status) => (
    <span
      className={`px-2 py-1 rounded-full text-xs font-medium ${
        status === "ativo"
          ? "bg-green-100 text-green-800"
          : "bg-red-100 text-red-800"
      }`}
    >
      {status === "ativo" ? "Ativo" : "Inativo"}
    </span>
  );

  const handleVisualizar = (item) => {
    setSelectedTemplate(item);
    setIsTemplateModalOpen(true);
  };

  const renderizarConteudo = (coluna, item) => {
    if (coluna.tipo === "status") {
      return renderizarStatus(item[coluna.campo]);
    }

    if (coluna.tipo === "acoes") {
      return (
        <div className="flex justify-center">
          <button
            className="text-gray-500 flex items-center justify-center h-6 w-6 rounded-full hover:bg-gray-100"
            onClick={(e) => {
              e.stopPropagation();
              handleVisualizar(item);
            }}
            title="Editar"
          >
            <FiEdit className="text-gray-600 text-base" />
          </button>
        </div>
      );
    }

    return item[coluna.campo] || "—";
  };

  return (
    <Table
      colunas={columnsTemplates}
      dados={dataTemplates}
      renderizarStatus={renderizarStatus}
      renderizarConteudo={renderizarConteudo}
    />
  );
};

export default TemplateEmail;
